import React, { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { NetworkCheck } from '@mui/icons-material';

//https://chatgpt.com/share/68305bff-5e64-8001-8490-9a973683ea1f
const formatSpeed = (bps: number | null) => {
  if (!bps) return '0 B/s';

  const bytesPerSecond = bps / 8;

  if (bytesPerSecond < 1024) return `${Math.round(bytesPerSecond)} B/s`;
  if (bytesPerSecond < 1048576)
    return `${Math.round(bytesPerSecond / 1024)} KB/s`;
  return `${Math.round(bytesPerSecond / 1048576)} MB/s`;
};

const getWifiIcon = (quality: number) => {
  return (
    <svg fill={'#fff'} viewBox="0 0 24 24">
      <path
        d="m12 20 3-3c-1.65-1.66-4.34-1.66-6 0z"
        fill={quality >= 0.2 ? '#fff' : '#666'}
      />
      <path
        d="m5 13 2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13"
        fill={quality >= 0.4 ? '#fff' : '#666'}
      />
      <path
        d="m1 9 2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9"
        fill={quality >= 0.6 ? '#fff' : '#666'}
      />{' '}
    </svg>
  );
};

interface NetworkStatsProps {
  quality?: number;
  recv?: number;
  send?: number;
  sx?: React.CSSProperties;
  onHoverIcon?: boolean;
}

const NetworkStats: React.FC<NetworkStatsProps> = ({
  quality = 0,
  recv = 0,
  send = 0,
  sx,
  onHoverIcon = false,
}) => {
  const [showStats, setShowStats] = useState<boolean>(false);

  useEffect(() => {
    setShowStats(!onHoverIcon);
  }, [onHoverIcon]);

  return (
    <Box sx={{ position: 'absolute', top: '.5rem', right: '.5rem', zIndex: 1 }}>
      {onHoverIcon && (
        <IconButton
          onMouseEnter={() => setShowStats(true)}
          onMouseLeave={() => setShowStats(false)}
          sx={{ color: '#fff', padding: '.25rem', zIndex: 1000 }}>
          <NetworkCheck />
        </IconButton>
      )}

      {showStats && (
        <Box
          sx={{
            cursor: 'default',
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.25)',
            padding: '.25rem .5rem',
            borderRadius: '.25rem',
            color: '#fff',
            fontSize: '.75rem',
            fontFamily: 'monospace',
            width: '7rem',
            ...sx,
          }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1.5rem auto',
              gap: '.25rem',
              alignItems: 'center',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {getWifiIcon(quality)}
            </Box>
            <div>{quality.toFixed(0)}</div>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>↓</Box>
            <div>{formatSpeed(recv)}</div>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>↑</Box>
            <div>{formatSpeed(send)}</div>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default NetworkStats;
